import { render, staticRenderFns } from "./LinkToOrcid.vue?vue&type=template&id=27749d4e"
import script from "./LinkToOrcid.vue?vue&type=script&lang=js"
export * from "./LinkToOrcid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports